import type Phaser from 'phaser';
import type { CombatVisualProfile, CombatEffectLayer } from '@/domain/combat/combat-visual-profile';

const COLOR: Record<CombatEffectLayer, number> = {
  flame: 0xff704d, wave: 0x5ac8fa, stone: 0xd4a76a, 'wind-streak': 0xe5fbff,
  leaf: 0x7ee787, 'shadow-smoke': 0xb187ff,
};

export function genomeEffectDescriptors(profile: CombatVisualProfile) {
  return profile.effectLayers.map((layer, index) => ({
    layer,
    color: COLOR[layer],
    radiusScale: profile.impactScale * (1 - index * 0.12),
  }));
}

export function buildGenomeCombatEffectRenderer(
  scene: Phaser.Scene,
  options: { reducedMotion?: boolean } = {},
) {
  return {
    burst(x: number, y: number, radius: number, profile: CombatVisualProfile): void {
      for (const [index, descriptor] of genomeEffectDescriptors(profile).entries()) {
        const targetRadius = radius * descriptor.radiusScale;
        const circle = scene.add
          .circle(x, y, options.reducedMotion ? targetRadius : 4 + index * 2, descriptor.color, 0.16)
          .setStrokeStyle(2, descriptor.color, 0.9)
          .setDepth(15 + index);
        if (options.reducedMotion) scene.time.delayedCall(220, () => circle.destroy());
        else scene.tweens.add({
          targets: circle,
          radius: targetRadius,
          alpha: 0,
          duration: 280,
          onUpdate: (tween) => circle.setRadius((tween.getValue() ?? 0) as number),
          onComplete: () => circle.destroy(),
        });
      }
    },
  };
}
